<template>
  <div style="border: 1px solid black;">
    The appointments for the selected month:
    <div>
      <i class="bi-calendar"></i>
    </div>
    <div style="border: 1px solid black;">
      <b-button @click="changeSelPeriod(-12)">
        &lt;&lt;
      </b-button>
      <b-button @click="changeSelPeriod(-1)">
        &lt;
      </b-button>
      <b-button @click="changeSelPeriod(0)">
        {{ selYear }} -- {{ selMonth+1 }}
      </b-button>
      <b-button @click="changeSelPeriod(1)">
        &gt;
      </b-button>
      <b-button @click="changeSelPeriod(12)">
        &gt;&gt;
      </b-button>
      <b-button class="float-right" @click="refreshData()">
        refresh
      </b-button>
    </div>
    <b-container fluid>
      <b-row style="border: 1px solid red;">
        <b-col v-for="wd in weekDays" :key="wd" style="border: 1px solid blue;">{{ wd }}</b-col>
      </b-row>
      <b-row v-for="(mw, mwndx) in monthWeeks" :key="mwndx" style="border: 1px solid red;">
        <b-col v-for="(mwd, mwdndx) in mw" :key="mwdndx" style="border: 1px solid blue; padding: 5px;">
          <div>
            <b-icon icon="square-fill" :style="{ color: getSpan1Color(mwd) }"></b-icon>
            <b-icon icon="square-fill" :style="{ color: getSpan2Color(mwd) }"></b-icon>
          </div>
          <b-button size="sm" variant="outline-primary" @click="changeSelDay(mwd)">
            {{ mwd.calDay }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <div v-if="selDay">
      <b-container>
        <div>
        the slots for {{ selDay.calDay }} / {{ selMonth +1 }} / {{ selYear }}
        </div>
        <b-row>
          <b-col v-for="(sl,slndx) in timeSlotsType" :key="slndx">
            <b-button
              :style="{ 'background-color': getSlotBtnColor(sl), width: '100%' }"
              @click="changeSelSlot(sl)">
              {{ sl }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal ref="tsApptModalRef" title="New appointment">
      <!-- <b-overlay :show="loading"> -->
        <t-s-appt ref="tsApptRef" :timeslot="selSlot" :isAdmin="isAdmin()"
          :occasionsList="formData.occasionsList" :paymentsList="formData.paymentsList"
          :apptData="formData.appt" :isOccupied="isSelSlotOccupied()"
          @valid-form-data-changed="handleTSApptValidFormDataChenged()">
        </t-s-appt>
        <!-- TODO: error text if pi not initialized -->
        <div v-if="paymInstKey && paymSdkLoaded && !isSelSlotOccupied()">
          <div>Karetendaten:</div>
          <div id="stripe-card-element"></div>
          <div id="stripe-card-errors" role="alert" style="color: red;"></div>
        </div>
      <!-- </b-overlay> -->
      <template v-slot:modal-footer>
        <b-button variant="warning"
          :disabled="isSelSlotOccupied()||!validFormData||loading"
          @click="handleOccpySelSlot()">Occupy</b-button>
        <b-button v-if="isAdmin()" variant="danger"
          :disabled="!isSelSlotOccupied()||loading"
          @click="handleDelSelSlot()">Delete</b-button>
        <b-button variant="primary" :disabled="loading"
          @click="handleCancelSelSlot()">Cancel</b-button>
      </template>
    </b-modal>

    <b-modal ref="apptSuccessModalRef" id="appt-success" title="Appointment Information!" ok-only>
      <p v-if="apptSuccSent">
        Your appointment was sent successfully!
      </p>
      <p v-else style="color: red;">
        An error occured during sending the appointment! Please try again later!
      </p>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import TSAppt from './TSAppt'

const timeSlotValueType = {
	locked: 'lck', // locked - no event can be added
	unlocked: 'ulck', // unlocked - event can be added
	editLocked: 'elck', // editLocked - locked for editing (new, edit, delete)
	occupied: 'occp' // occupied - already occupied
}

const calMonthType = {
	prev: 'prev', // previous month
	curr: 'curr', // current month
	next: 'next' // next month
}

const modeType = {
  customer: 'customer',
  admin: 'admin'
}

const PIT_DEFS = { pitStripe: 'pit-stripe', pitPaypal: 'pit-paypal' }
const DEFAULT_APPT = { title: '', descr: '', name: '', email: '' }

export default {
  name: 'timeslot-calendar',
  version: '0.0.2',
  props: {
    mode: { // customer / admin
      type: String,
      default: modeType.customer,
      validator: function (v) {
        return [modeType.customer, modeType.admin].indexOf(v) !== -1
      }
    },
    instKey: {
      type: String,
      required: true
    },
    paymInstKey: {
      type: String,
      required: false
    }
  }, // props
  components: {
    TSAppt
  }, // components
  data () {
    return {
      loading: false,
      timeSlotsType: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
        '14:00', '15:00', '16:00', '17:00', '18:00'],
      weekDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      monthWeeks: [],
      monthSlots: {},
      selSlot: null,
      // selSlotOrigStatus: null,
      selDay: null,
      selYear: (new Date()).getFullYear(), // selected year in the calendar header
      selMonth: (new Date()).getMonth(), // selected month (0 - 11)
      paymSdkLoaded: false,
      piType: null,
      piMerchantId: null,
      stripe: {
        inst: null,
        elements: null,
        card: null,
        cardValid: false
      },
      apptSuccSent: false,
      // validTSApptFormData: null,
      validFormData: false,
      formData: {
        occasionSelected: null,
        occasionsList: [],
        paymentsList: [],
        appt: Object.assign({}, DEFAULT_APPT)
      }
    }
  }, // data
  async mounted () {
    console.log('TRACE-REMOVE: TimeslotCalendar.mounted!')
    // TODO: check if necessary
    this.refreshData()
    if (this.paymInstKey) {
      try {
        const _glapiPaymResp = await axios.get(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/preferedPIDetails')

        if ('success' === _glapiPaymResp.data.status) {
          this.piType = _glapiPaymResp.data.payload.ppiDetails.piType
          this.piMerchantId = _glapiPaymResp.data.payload.ppiDetails.merchantId
          if (this.isStripePI) {
            this.loadStripeSdk(() => this.paymSdkLoaded = true)
          }
        } else {
          throw new Error('Payment API call failed! Status: ' + _glapiPaymResp.data)
        }
        // this.loadPaypalSdk()
      } catch (e) {
        console.error('Error accessing payments API! Exception is: ', e)
      }
    }
  }, // mounted
  computed: {
    isStripePI () {
      return this.piType === PIT_DEFS.pitStripe
    }, // isStripePI
    validCard: function () {
      return this.stripe.cardValid
    } // validCard
  }, // computed
  watch: {}, // watch
  methods: {
    /* ----- handler methods ----- */
    async refreshData () {
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/timeslotCaldr/' + this.selYear + '/' + this.selMonth)
        // this.content = resp.data
        this.monthSlots = _resp.data.payload.timeslotCaldr
        // console.log('TRACE-REMOVE: TimeslotCalendar: resp is: ', _resp)
      } catch (e) {
        this.content = 'Error loading the content!'
        console.error('ERROR: Exception is: ', e)
      }
      this.monthWeeks = this.getMonthWeeks(this.selYear, this.selMonth)
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/occasionsList')
        // console.log('TRACE-REMOVE: refreshData: _resp is: ', _resp)
        this.formData.occasionsList = _resp.data.payload.occasionsList
        this.formData.paymentsList = _resp.data.payload.paymentsList
      } catch (e) {
        console.error('ERROR: Exception getting the occasionsList is: ', e)
      }
      // this.formData.occasionsList.unshift({ value: null, text: 'Please selecr value' })
    }, // refreshData
    changeSelPeriod(months) {
      const newDate = new Date(this.selYear, this.selMonth + months, 1)
      this.selYear = newDate.getFullYear()
      this.selMonth = newDate.getMonth()
      this.refreshData()
    }, // changeSelPeriod
    changeSelDay (selDay) {
      this.selSlot = null
      this.selDay = null
      if (this.isCurrMonth(selDay)) {
        this.selDay = selDay
      }
    }, // changeSelDay
    async changeSelSlot(sl) {
      this.selSlot = null
      let _showTSAppt = false
      if (this.mode === modeType.admin) {
        if (!this.monthSlots[this.selDay.calDay] ||
          !this.monthSlots[this.selDay.calDay].slots[sl] ||
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.locked) {
          await axios.post(config.glapiBaseUri + '/schedule/' + this.instKey +
            '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
            this.selDay.calDay + '/' + sl)
          this.refreshData()
        } else if (this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.unlocked ||
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.occupied) {
          this.selSlot = sl
          _showTSAppt = true
          if (this.monthSlots[this.selDay.calDay].appts &&
            this.monthSlots[this.selDay.calDay].appts[sl]) {
            this.formData.appt = this.monthSlots[this.selDay.calDay].appts[sl]
          } else {
            this.formData.occasionSelected = null
            this.formData.appt = Object.assign({}, DEFAULT_APPT)
          }
        }
      } else if (this.mode === modeType.customer) {
        if (this.monthSlots[this.selDay.calDay] &&
          this.monthSlots[this.selDay.calDay].slots[sl] &&
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.unlocked) {
          this.selSlot = sl
          this.formData.occasionSelected = null
          this.formData.appt = Object.assign({}, DEFAULT_APPT)
          _showTSAppt = true
        }
      }
      if (_showTSAppt) {
        this.$refs.tsApptModalRef.show()
        Vue.nextTick(() => {
          this.validTSApptFormData = this.$refs.tsApptRef.validFormData
          if (this.paymInstKey && this.paymSdkLoaded && !this.isSelSlotOccupied()) {
            this.stripe.cardValid = false
            this.mountStripeCardEl()
          }
        })
      }
    }, // changeSelSlot
    async handleDelSelSlot () {
      // TODO: check if this restriction makes sence?
      if (this.monthSlots[this.selDay.calDay] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] !== timeSlotValueType.locked) {
        await axios.delete(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
          this.selDay.calDay + '/' + this.selSlot)
        this.refreshData()
        this.selSlot = null
        this.$refs.tsApptModalRef.hide()
      }
    }, // handleDelSelSlot
    async handleOccpySelSlot () {
      if (!this.$refs.tsApptRef.isValidFormData()) {
        // TODO: some indication
        return
      }

      const _fd = this.$refs.tsApptRef.getFormData()
      this.formData.appt.paymAmount = _fd.appt.paymAmount
      // TODO: try/catch
      try {
        this.loading = true
        if (this.paymInstKey) {
          await this.handleCreateStripeOrder()
        }
        await axios.put(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
          this.selDay.calDay + '/' + this.selSlot,
          {
            status: timeSlotValueType.occupied,
            appt: _fd.appt
          })
        this.apptSuccSent = true
        this.refreshData()
      } catch (e) {
        console.log('ERROR: TimeslotCaldr.handleOccpySelSlot: Error occured! Exception is: ', e)
        this.apptSuccSent = false
      } finally {
        this.loading = false
        this.selSlot = null
        this.$refs.apptSuccessModalRef.show()
        this.$refs.tsApptModalRef.hide()
      }
    }, // handleOccpySelSlot
    async handleCreateStripeOrder () {
      console.log('INFO: TimeslotCaldr: PO creation started!')
      const _resp = await axios.post(config.glapiBaseUri + '/paym/' +
        this.paymInstKey + '/paymentOrder/pit-stripe',
        { amount: this.formData.appt.paymAmount })
      console.log('INFO: TimeslotCaldr: PO created!')
      const _donor = this.formData.name ? this.formData.name : 'Anonymous'
      const _result = await this.stripe.inst.confirmCardPayment(
        _resp.data.payload.paymentOrder.pmIntnClientSecret, {
          payment_method: {
            card: this.stripe.card,
            billing_details: {
              name: _donor
            }
          }
        })
      if (_result.error) {
        throw new Error('GL Stripe confirm card payment failed! Error is: ' + _result.error)
      } else {
        // The payment has been processed!
        if (_result.paymentIntent.status === 'succeeded') {
          console.log('INFO: TimeslotCaldr: PO confirmed success!')
          const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
          let iter = 0
          let finalized = false
          while (!finalized && iter++ < 3) {
            try {
              await sleep(3000)
              const _resp2 = await axios.put(config.glapiBaseUri + '/paym/' +  // eslint-disable-line no-unused-vars
                this.paymInstKey + '/paymentOrder/pit-stripe',
                { orderId: _resp.data.payload.paymentOrder.ppOrderId }
              )
              console.log('INFO: TimeslotCaldr: PO finalized!')
              // this.formData = _getDefaultFormData()
              // this.formData.amount = this.amountList[0]
              finalized = true
            } catch (e2) {
              console.log('ERROR: OrderBasketBtn: Order still not finalized! Exception is: ', e2)
            }
          }
          // _orderSucc = finalized
          if (!finalized) {
            throw new Error('GL Stripe transaction could not be finalized! Check your payments order dashboard!')
          }
        }
      }
    }, // handleCreateStripeOrder
    handleCancelSelSlot () {
      this.$refs.tsApptModalRef.hide()
      this.selSlot = null
    }, // handleCancelSelSlot
    handleTSApptValidFormDataChenged () {
      console.log('TRACE-REMOVE: handleTSApptValidFormDataChenged!')
      this.validFormData = this.paymInstKey ?
        this.validCard && this.$refs.tsApptRef.validFormData :
        this.$refs.tsApptRef.validFormData
      console.log('TRACE-REMOVE: handleTSApptValidFormDataChenged: ' +
        'this.validFormData is: ', this.validFormData)
      // TODO: check if :key="renderCounter" is not better?
      this.$forceUpdate()
    }, // handleTSApptValidFormDataChenged
    /* ----- helper methods ----- */
    loadStripeSdk (cb, mountCb) {
      console.log('INFO: loading StripeSdk ...')
      const script = document.createElement('script')
      script.src = config.stripeSdkUrl
      script.addEventListener('load', () => {
        // eslint-disable-next-line
        this.stripe.inst = Stripe(config.stripePlatformPK, {
          apiVersion: '2020-08-27',
          stripeAccount: this.piMerchantId
        })
        this.stripe.elements = this.stripe.inst.elements()
        this.stripe.card = this.stripe.elements.create('card')
        // card.mount('#card-element');
        console.log('INFO: StripeSdk loaded!')
        if (cb) {
          cb()
        }
        if (mountCb) {
          mountCb()
          console.log('INFO: Stripe mounted!')
        }
      })
      document.head.appendChild(script)
    }, // loadStripeSdk
    mountStripeCardEl () {
      this.stripe.card.mount('#stripe-card-element')
      this.stripe.card.on('change', ({ complete, error }) => {
        let displayError = document.getElementById('stripe-card-errors')
        if (error) {
          this.stripe.cardValid = false
          displayError.textContent = error.message
        } else if (complete) {
          this.stripe.cardValid = true
          displayError.textContent = ''
        } else {
          this.stripe.cardValid = false
          displayError.textContent = ''
        }
      })
    }, // mountStripeCardEl
    getSlotBtnColor (sl) {
      let _color = 'gray'
      let _slotValue
      if (this.monthSlots[this.selDay.calDay]) {
        _slotValue = this.monthSlots[this.selDay.calDay].slots[sl]
      }
      if (_slotValue == timeSlotValueType.unlocked) {
        _color = 'green'
      } else if (_slotValue == timeSlotValueType.occupied) {
        _color = 'red'
      } else if (_slotValue == timeSlotValueType.editLocked) {
        _color = 'blue'
      }
      return _color
    }, // getSlotBtnColor
    getSpan1Color (wd) {
      var _color = 'gray'
      if (this.isCurrMonth(wd)){
        if (this.hasSlotsOfType(wd.calDay, timeSlotValueType.unlocked)) {
          _color = 'green'
        } else if (this.hasAllSlotsOfType(wd.calDay, timeSlotValueType.occupied)) {
          _color = 'red'
        }
      }
      return _color
    }, // getSpan1Color
    getSpan2Color (wd) {
      var _color = 'gray'
      if (this.isCurrMonth(wd)){
        if (this.hasAllSlotsOfType(wd.calDay, timeSlotValueType.unlocked)) {
          _color = 'green'
        } else if (this.hasSlotsOfType(wd.calDay, timeSlotValueType.occupied)) {
          _color = 'red'
        }
      }
      return _color
    }, // getSpan2Color
    hasSlotsOfType (day, slType) {
      var _ret = false
      if (this.monthSlots[day] && this.monthSlots[day].slots) {
        if (Object.values(this.monthSlots[day].slots).some(e => e === slType)) {
          _ret = true
        }
      }
      return _ret
    }, // hasSlotsOfType
    hasAllSlotsOfType (day, slType) {
      var _ret = true
      if ((!this.monthSlots[day] || !this.monthSlots[day].slots)) {
        _ret = false
      } else if (this.monthSlots[day] && this.monthSlots[day].slots) {
        const _slotsValues = Object.values(this.monthSlots[day].slots)
        if (this.timeSlotsType.length !== _slotsValues.length ||
          _slotsValues.some(e => e !== slType)) {
          _ret = false
        }
      }
      return _ret
    }, // isAllEventSlotsOfEvType
    isAdmin () {
      return this.mode === modeType.admin
    }, // isAdmin
    isSelSlotOccupied () {
      let ret = false
      if (this.selSlot && this.monthSlots[this.selDay.calDay] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] === timeSlotValueType.occupied) {
        ret = true
      }
      return ret
    }, // isSelSlotOccupied
    // TODO: externalize it!
    isCurrMonth (month) {
      var currMonth = false
      if (month.calMonth === calMonthType.curr) {
        currMonth = true
      }
      return currMonth
    }, // isCurrMonth
    getMonthWeeks (year, month011) {
      let weeksDays = [],
        weekDays = [],
        numDaysMonth = (new Date(year, month011+1, 0)).getDate(),
        currentDOM = 1,
        startDOWMoSu17 = (new Date(year, month011, 1)).getDay() !== 0 ?
          (new Date(year, month011, 1)).getDay() : 7

      var i
      // calculate first week last/prev month days
      for (i = (-1*startDOWMoSu17 + 2); i < currentDOM; i++) {
        weekDays.push({ calDay: (new Date(year, month011, i)).getDate(),
          calMonth: calMonthType.prev })
      }
      // first week this/current month days
      for (i = startDOWMoSu17; i <= 7; i++) {
        weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
      }
      weeksDays.push(weekDays)
      weekDays = []

      // this/current month full weeks
      do {
        for (i = 1; i <= 7; i++) {
          weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
        }
        weeksDays.push(weekDays)
        weekDays = []
      } while ((currentDOM+6) <= numDaysMonth)

      // last week this/current month
      if (currentDOM <= numDaysMonth) {
        var daysRemaining = 7
        while (currentDOM <= numDaysMonth) {
          weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
          daysRemaining--
        }
        // last week days next month
        for (i = 1; i <= daysRemaining; i++) {
          weekDays.push({ calDay: (new Date(year, month011+1, i)).getDate(),
            calMonth: calMonthType.next })
        }
        weeksDays.push(weekDays)
      }
      return weeksDays
    } // getMonthWeeks
  } // methods
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
/* @import '~bootstrap-vue/dist/bootstrap-vue.css'; */
</style>
